export const apiEndpoint = 'https://victorvergarareact.cdn.prismic.io/api/v2'

export const accessToken = 'MC5ZTXk3cFJNQUFDRUFtR3BF.77-9fO-_vRYr77-9GO-_ve-_ve-_ve-_ve-_ve-_ve-_ve-_ve-_vRxy77-977-9fhps77-9d--_ve-_ve-_ve-_vVjvv70K'

export const linkResolver = (doc) => {

  if (doc === '/portfolio') return `/portfolio`
  if (doc.type === 'project') return `/${doc.uid}`

  return '/'
}